import { useEffect, useRef } from "react";
import { Dispatch } from "redux";
import { RaceInfoMyBets } from "@tvg/ts-types/Race";

import { updateRacesMyBets } from "../redux/actions";

type Props = {
  dispatch: Dispatch;
  races: RaceInfoMyBets[];
};

export const useMyBetsUpdateRaces = (props: Props) => {
  const { dispatch, races } = props;
  const prevRacesRef = useRef<RaceInfoMyBets[] | null>(null);

  useEffect(() => {
    if (races && races.length > 0 && races !== prevRacesRef.current) {
      prevRacesRef.current = races;
      dispatch(updateRacesMyBets(races));
    }
  }, [races]);
};

export default useMyBetsUpdateRaces;
